import { Pipe, PipeTransform } from '@angular/core';
import { Trainer } from '../../_services';

@Pipe({ name: 'filterByLanguage' })
export class TrainersLanguagePipe implements PipeTransform {
    transform(
        trainers: any[],
        language: string,
        filterMetadata?: any,
        filterLabel?: string
    ): any[] {
        const filteredTrainers = trainers.filter((trainer) => {
            return (
                language === 'all' ||
                trainer.languages
                    .map((language) => language.code)
                    .includes(language)
            );
        });
        switch (filterLabel) {
            case 'name': {
                filterMetadata.countName = filteredTrainers.length;
                break;
            }
            case 'can': {
                filterMetadata.countCan = filteredTrainers.length;
                break;
            }
            case 'given': {
                filterMetadata.countGiven = filteredTrainers.length;
                break;
            }
            case 'wished': {
                filterMetadata.countWished = filteredTrainers.length;
                break;
            }
            case 'followed': {
                filterMetadata.countFollowed = filteredTrainers.length;
                break;
            }
            case 'refuse': {
                filterMetadata.countRefuse = filteredTrainers.length;
                break;
            }
            default: {
                break;
            }
        }
        return filteredTrainers;
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/trainers-language.pipe.ts